import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Guests have no passwords any more (owner, 2026-10-12): everyone signs in
 * with a code we email, Google or Apple, old password accounts included, and
 * the API refuses password routes for guests (packages/auth password-gate).
 * A reset link still sitting in an inbox lands on sign-in, where the same
 * email gets a code.
 */
export const Route = createFileRoute("/reset-password")({
  beforeLoad: () => {
    throw redirect({ to: "/sign-in", statusCode: 301 });
  },
});
